(() => {
  if (window.slVideoReady) return;
  window.slVideoReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pauseOthers = (current) => {
    document.querySelectorAll('[data-sl-video] video').forEach((video) => {
      if (video !== current && !video.paused && !video.muted) video.pause();
    });
  };

  const play = (video) => {
    const attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(() => {});
  };

  function playWithSound(container) {
    const video = container.querySelector('video');
    if (!video) return;
    pauseOthers(video);
    video.muted = false;
    video.loop = false;
    video.controls = true;
    video.currentTime = 0;
    container.classList.add('is-playing-sound');
    play(video);
    video.focus({ preventScroll: true });
  }

  /* Full view player */

  const pausedPreviews = new Set();

  function pausePreviews() {
    document.querySelectorAll('[data-sl-video] video').forEach((video) => {
      if (video.paused) return;
      video.pause();
      if (video.muted) pausedPreviews.add(video);
    });
  }

  function resumePreviews() {
    pausedPreviews.forEach((video) => {
      if (video.isConnected) play(video);
    });
    pausedPreviews.clear();
  }

  function setEnded(player, ended) {
    const end = player.querySelector('[data-sl-player-end]');
    if (end) end.hidden = !ended;
    if (ended) player.classList.remove('is-paused');
  }

  function syncSound(player, video) {
    const sound = player.querySelector('[data-sl-player-sound]');
    if (sound) sound.setAttribute('aria-pressed', String(video.muted));
  }

  function setProgress(player, video) {
    const bar = player.querySelector('[data-sl-player-progress]');
    if (bar && video.duration) bar.style.transform = `scaleX(${video.currentTime / video.duration})`;
  }

  function openPlayer(player) {
    const video = player.querySelector('video');
    if (!video) return;
    pausePreviews();
    setEnded(player, false);
    if (!player.open) {
      player.showModal();
      document.documentElement.classList.add('sl-player-open');
    }
    video.muted = false;
    video.currentTime = 0;
    syncSound(player, video);
    setProgress(player, video);
    play(video);
  }

  function closePlayer(player) {
    if (player && player.open) player.close();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-sl-player-open]');
    if (opener) {
      const player = document.getElementById(opener.getAttribute('data-sl-player-open'));
      if (player) {
        event.preventDefault();
        openPlayer(player);
      }
      return;
    }

    const player = event.target.closest('[data-sl-player]');
    if (player) {
      if (event.target.closest('[data-sl-player-close]') || event.target === player || event.target.matches('.sl-player__inner')) {
        closePlayer(player);
        return;
      }
      if (event.target.closest('[data-sl-player-replay]')) {
        openPlayer(player);
        return;
      }
      const video = player.querySelector('video');
      if (video && event.target.closest('[data-sl-player-toggle]')) {
        if (video.paused) play(video);
        else video.pause();
        return;
      }
      if (video && event.target.closest('[data-sl-player-sound]')) {
        video.muted = !video.muted;
        syncSound(player, video);
        return;
      }
      if (event.target.closest('.sl-player__bar a, .sl-player__bar [data-sl-enquire]')) {
        closePlayer(player);
      }
      return;
    }

    const trigger = event.target.closest('[data-sl-video-sound], [data-sl-video-play]');
    if (!trigger) return;
    const container = trigger.closest('[data-sl-video]');
    if (container) playWithSound(container);
  });

  const playerOf = (event) => event.target.closest && event.target.closest('[data-sl-player]');

  document.addEventListener('ended', (event) => {
    const player = playerOf(event);
    if (player) setEnded(player, true);
  }, true);

  ['play', 'pause'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const player = playerOf(event);
      if (player) player.classList.toggle('is-paused', event.target.paused && !event.target.ended);
    }, true);
  });

  document.addEventListener('timeupdate', (event) => {
    const player = playerOf(event);
    if (player) setProgress(player, event.target);
  }, true);

  document.addEventListener('close', (event) => {
    if (!event.target.matches || !event.target.matches('[data-sl-player]')) return;
    const video = event.target.querySelector('video');
    if (video) video.pause();
    setEnded(event.target, false);
    if (!document.querySelector('[data-sl-player][open]')) {
      document.documentElement.classList.remove('sl-player-open');
      resumePreviews();
    }
  }, true);

  document.addEventListener('play', (event) => {
    if (event.target.tagName === 'VIDEO' && !event.target.muted) pauseOthers(event.target);
  }, true);

  /* Muted previews that play only while on screen, so a page of doctors does not download every video at once. */
  const previewObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting) {
          video.pause();
        } else if (!reduceMotion.matches && !document.querySelector('[data-sl-player][open]')) {
          video.muted = true;
          play(video);
        }
      });
    }, { rootMargin: '200px 0px' })
    : null;

  function watchPreviews(scope) {
    scope.querySelectorAll('[data-sl-autoplay] video').forEach((video) => {
      if (previewObserver) previewObserver.observe(video);
    });
  }

  ['playing', 'pause'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const tile = event.target.closest && event.target.closest('[data-sl-autoplay]');
      if (tile) tile.classList.toggle('is-playing', type === 'playing');
    }, true);
  });

  function init() {
    watchPreviews(document);
    if (!reduceMotion.matches) return;
    document.querySelectorAll('[data-sl-video] video[autoplay]').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    window.setTimeout(() => {
      if (!document.querySelector('[data-sl-player][open]')) {
        document.documentElement.classList.remove('sl-player-open');
      }
    });
  });
})();
